/* =====================================================================
   Free Gift Upsells — 购物车主车 / 赠品「强制绑定」（Lectric 式）

   职责三件事：
   1) 主车数量接管：改主车数量时，免费赠品数量在同一个 /cart/update.js
      请求里同步；减到 0 = 连带删（无需确认）。孤儿提示条保留作兜底
      （历史遗留 / 异常数据），正常操作不会再产生孤儿。
   2) 孤儿清理：顾客点提示条按钮才移除孤儿行。
   3) 「Clear cart」按钮 → 二次确认 → /cart/clear.js → 重建。

   为什么用事件委托：抽屉每次加购/改数量都会用 cart.ajax.liquid 的
   markup 整体重渲染 [data-products]，挂在按钮上的监听会跟着消失。
   绑在 document 上就不会。

   依赖事实（Motion 11.0.0，theme.js）：
   - QtySelector（theme.js:3019）的 +/- 和 input change 监听都绑在
     元素自身上 → 我们用 document **捕获阶段** 监听，先到先拦，
     stopImmediatePropagation 后主题逻辑不会跑，无双请求。
   - CartForm.quantityChanged 对 qty=0 有 `if (!key || !qty) return;`
     的拦截，主题自己删不了行 → 主车行的删除只能靠我们接管。
   - 重建先例 theme.js:8267 —— new theme.CartForm(form).buildCart()。
   - 加价购行（_fgu_addon）不在接管范围：顾客单独付费，数量独立。

   已知边界：赠品归属按主车 handle 记（line item properties 只有 handle
   没有 key），同 handle 不同变体的两行主车共享同一批赠品，无法按行区分。
   ===================================================================== */

(function () {
  'use strict';

  if (window.__fguCartBind) return;
  window.__fguCartBind = true;

  function rebuildCart() {
    /* 购物车页整页刷新最可靠（页头数量、合计、折扣一起更新） */
    if (document.body.classList.contains('template-cart')) {
      window.location.reload();
      return;
    }

    /* 抽屉：沿用 theme.js:8267 的强制重建套路 */
    try {
      var form = document.querySelector('#CartDrawerForm');
      if (form && form.parentNode) {
        new theme.CartForm(form).buildCart();
        return;
      }
    } catch (e) { /* 落到兜底 */ }

    window.location.reload();
  }

  function syncCartBubble(cart) {
    try {
      var bubble = document.querySelector('.cart-link__bubble');
      if (!bubble) return;
      if (cart && cart.item_count > 0) {
        bubble.classList.remove('hide');
        bubble.textContent = cart.item_count;
      } else {
        bubble.classList.add('hide');
      }
    } catch (e) { /* 气泡更新失败不阻塞主流程 */ }
  }

  /* ---------- 主车数量接管（捕获阶段，先于主题 QtySelector） ---------- */

  function isParentRow(row) {
    /* 可接管行 = 带数量控件，且不是正常嵌套赠品行（它们本就没有控件）。
       孤儿赠品行也纳入接管：主题对 qty=0 直接 return，孤儿行自己删不掉。 */
    return !!(row && row.querySelector('.js-qty__wrapper') &&
      !(row.classList.contains('fgu-cart-child') &&
        !row.classList.contains('fgu-cart-child--orphan')));
  }

  function findChildKeys(row) {
    var handle = row.getAttribute('data-fgu-handle');
    if (!handle) return [];
    var keys = [];
    var kids = document.querySelectorAll(
      '.cart__item[data-fgu-parent-key="' + handle + '"]');
    for (var i = 0; i < kids.length; i++) {
      /* 孤儿不归本主车管（它的父 handle 理论上匹配不到，这里双保险） */
      if (!kids[i].classList.contains('fgu-cart-child--orphan')) {
        keys.push(kids[i].getAttribute('data-key'));
      }
    }
    return keys;
  }

  function updateParentAndChildren(key, newQty, wrapper) {
    if (newQty < 0) newQty = 0;
    var updates = {};
    updates[key] = newQty;

    /* 赠品 key 在点击时才从 DOM 收集，重建后自动是最新的一批 */
    var row = document.querySelector('.cart__item[data-key="' + key + '"]');
    var childKeys = row ? findChildKeys(row) : [];
    childKeys.forEach(function (k) { updates[k] = newQty; });

    if (wrapper) wrapper.classList.add('is-loading');

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart && cart.status === 422) {
          throw new Error(cart.description || cart.message || 'Unable to update cart');
        }
        syncCartBubble(cart);
        rebuildCart();
      })
      .catch(function (err) {
        if (wrapper) {
          wrapper.classList.remove('is-loading');
          delete wrapper.dataset.fguBusy;
        }
        if (window.console) console.warn('[fgu-cart-bind]', err && err.message);
        alert((err && err.message) || 'Unable to update cart. Please try again.');
      });
  }

  function handleQtyIntercept(evt) {
    var input = null;
    var row = null;
    var newQty = null;

    if (evt.type === 'click') {
      var adjust = evt.target.closest ? evt.target.closest('.js-qty__adjust') : null;
      if (!adjust) return;
      row = adjust.closest('.cart__item[data-key]');
      if (!isParentRow(row)) return;
      var wrapper = adjust.closest('.js-qty__wrapper');
      input = wrapper.querySelector('.js-qty__num');
      var cur = parseInt(input.value, 10) || 0;
      newQty = adjust.classList.contains('js-qty__adjust--plus') ? cur + 1 : cur - 1;
    } else if (evt.type === 'change') {
      input = evt.target;
      if (!input.classList || !input.classList.contains('js-qty__num')) return;
      row = input.closest('.cart__item[data-key]');
      if (!isParentRow(row)) return;
      newQty = parseInt(input.value, 10) || 0;
    } else {
      return;
    }

    /* 没挂免费赠品的主车 → 交还主题原生逻辑 */
    if (!findChildKeys(row).length) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();
    evt.stopPropagation();

    var key = row.getAttribute('data-key');
    var w = row.querySelector('.js-qty__wrapper');
    if (w && w.dataset.fguBusy === '1') return;
    if (w) w.dataset.fguBusy = '1';

    updateParentAndChildren(key, newQty, w);
  }

  /* capture: true —— 必须抢在 QtySelector 的元素级监听之前 */
  document.addEventListener('click', handleQtyIntercept, true);
  document.addEventListener('change', handleQtyIntercept, true);

  document.addEventListener('click', function (evt) {
    /* 清空购物车：/cart/clear.js 一个请求搞定，重建复用同一个 rebuildCart()
       必须 confirm —— 清空是不可逆操作，误点代价太大 */
    var clearBtn = evt.target.closest ? evt.target.closest('[data-clear-cart]') : null;
    if (clearBtn) {
      if (clearBtn.disabled) return;
      if (!window.confirm('Remove all items from your cart?')) return;

      clearBtn.disabled = true;
      clearBtn.textContent = 'Clearing…';

      fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function () {
          /* 抽屉页脚不会被 cartMarkup 重渲染，按钮状态得自己复位，
             否则会一直卡在 "Clearing…" */
          clearBtn.disabled = false;
          clearBtn.textContent = 'Clear cart';
          syncCartBubble({ item_count: 0 });
          rebuildCart();
        })
        .catch(function () {
          clearBtn.disabled = false;
          clearBtn.textContent = 'Clear cart';
          alert('Unable to clear cart. Please try again.');
        });
      return;
    }

    var btn = evt.target.closest ? evt.target.closest('[data-fgu-remove-orphans]') : null;
    if (!btn) return;

    var wrap = btn.closest('[data-fgu-orphan-keys]');
    if (!wrap || btn.disabled) return;

    var keys = (wrap.getAttribute('data-fgu-orphan-keys') || '')
      .split(',')
      .filter(function (k) { return !!k; });
    if (!keys.length) return;

    btn.disabled = true;
    btn.textContent = 'Removing…';

    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart && cart.status === 422) {
          throw new Error(cart.description || cart.message || 'Unable to update cart');
        }
        syncCartBubble(cart);
        rebuildCart();
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = 'Remove them';
        if (window.console) console.warn('[fgu-cart-bind]', err && err.message);
        alert((err && err.message) || 'Unable to update cart. Please try again.');
      });
  }, false);
})();
